/**
 * Labstep
 *
 * @module components/ResourceLocation/Form/fields
 * @desc ResourceLocation fields
 */

import { FieldType } from 'labstep-web/constants/form';
import type { FieldWithoutActionProps } from 'labstep-web/core/Form/Reusable/types';
import rules from 'labstep-web/services/validation/rules';
import { mixed } from 'yup';

export const fieldResourceLocationName: FieldWithoutActionProps = {
  fieldType: FieldType.Text,
  name: 'name',
  validation: rules.resource_location.name,
  placeholder: 'Enter name e.g. `Box 55`',
  header: true,
};

export const fieldResourceLocationNameMultiple: FieldWithoutActionProps =
  {
    fieldLabel: 'Names',
    name: 'names',
    validation: mixed().required(),
    placeholder: 'Enter name',
    fieldType: FieldType.SelectMulti,
  };

export const DEFAULT_DIMENSION_VALUE = 10;

export const fieldResourceLocationMapRows: FieldWithoutActionProps = {
  fieldType: FieldType.Text,
  name: 'rows',
  fieldLabel: 'Rows',
  validation: rules.resource_location.map_rows,
  header: true,
};

export const fieldResourceLocationMapColumns: FieldWithoutActionProps =
  {
    fieldType: FieldType.Text,
    name: 'columns',
    fieldLabel: 'Columns',
    validation: rules.resource_location.map_columns,
    header: true,
  };
